import { useQuery } from '@tanstack/react-query';
import { utilityJWECacheKey } from '../cacheKeys';
import { queryFnFactoryToken } from './query';
export function useUtilityJWETokenQuery({ config, keyProps, queryOptions = {} }) {
    return useQuery({
        queryKey: utilityJWECacheKey(keyProps),
        queryFn: queryFnFactoryToken(config, keyProps),
        ...queryOptions
    });
}
